export default __webpack_public_path__ + "static/media/DCA_580x400.402676f4.jpg";